import React from "react";

import StyleGuideComponent from "../components/common/StyleGuide";

export const StyleGuide = () => <StyleGuideComponent />;
